import {
  gsap
} from 'gsap'

import {
  ScrollTrigger
} from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default {
  mounted() {
    // Mouse move
    const mouseMove = gsap.utils.toArray('.mouse-move')
    if (mouseMove.length) {
      window.addEventListener("mousemove", (evt) => {
        const percentX = gsap.utils.normalize(0, innerWidth, evt.pageX)
        const percentY = gsap.utils.normalize(0, innerWidth, evt.pageY)

        mouseMove.forEach(element => {
          // console.log('evt:', evt.pageY - gsap.getProperty(element, "width"))
          // console.log('gsap.getProperty(element):', gsap.getProperty(element, "offsetLeft"))

          const maxX = gsap.getProperty(element, "width") * 0.05
          const maxY = gsap.getProperty(element, "height") * 0.05

          gsap.to(element, {
            duration: 0.2,
            x: percentX * maxX - maxX / 2,
            y: percentY * maxY - maxY / 2,
            overwrite: true
          })
        })
      })
    }

    // Oh! animation
    const ohs = gsap.utils.toArray('.oh')
    if (ohs.length) {
      ohs.forEach(element => {
        gsap.to(element.children[0], {
          scrollTrigger: {
            trigger: element,
            start: 'top 80%',
            markers: false,
            toggleActions: 'play none none none'
          },
          y: 0,
          rotate: 0,
          duration: 1,
        })
      })
    }

    // Stagger reveal
    const staggerReveal = gsap.utils.toArray('.stagger-reveal')
    if (staggerReveal.length) {
      staggerReveal.forEach(element => {
        gsap.to(element.children, {
          scrollTrigger: {
            trigger: element,
            start: 'top 70%',
            end: 'top top',
            // markers: true,
          },
          opacity: 1,
          y: 0,
          stagger: 0.2,
        })
      })
    }

    // Parallax
    const parallax = gsap.utils.toArray('.parallax')
    if (parallax.length) {
      gsap.to(parallax, {
        scrollTrigger: {
          // trigger: parallax,
          // start: 'top 80%',
          scrub: 1,
          // markers: true,
        },
        y: '-100px',
      })
    }

    // Boxes animation
    if (this.$refs['animated-boxes']) {
      setTimeout(() => {
        const tl = gsap.timeline()

        tl.to(".animated-boxes .box:nth-child(1)", {
          opacity: 0,
          left: "+=200",
        }).to(".animated-boxes .box:nth-child(2)", {
          opacity: 1,
          left: "50%",
          delay: -0.3
        }).to(".animated-boxes .box:nth-child(2)", {
          opacity: 0,
          left: "+=200",
        }).to(".animated-boxes .box:nth-child(3)", {
          opacity: 1,
          left: "50%",
          delay: -0.3
        })

        ScrollTrigger.create({
          animation: tl,
          trigger: ".animated-boxes",
          start: 'center center',
          // end: '100% 50%',
          end: () => '+=' + this.$refs['animated-boxes'].offsetHeight * 3,
          scrub: 1,
          pin: '.animated-boxes-wrapper',
          ease: 'none',
          // markers: true
        })

      }, 200)
    }

    if (this.$refs['box-wrapper-video']) {
      ScrollTrigger.create({
        trigger: ".animated-boxes-wrapper",
        start: "0% 0%",
        onEnter: () => {
          this.$refs['box-wrapper-video'].$el.style.position = 'fixed'
        },
        onLeaveBack: () => {
          this.$refs['box-wrapper-video'].$el.style.position = 'absolute'
        },
        // markers: true
      })
    }

    // Fleet fixed buttons
    if (this.$refs['btn-fixed-left-wrapper']) {
      ScrollTrigger.create({
        trigger: "#reference-list",
        start: "0% 50%",
        end: "100% 50%",
        onEnter: () => {
          gsap.to(this.$refs['btn-liner-list'], {
            display: 'block',
            opacity: 1,
          })

          gsap.to(this.$refs['btn-reference-list'], {
            display: 'none',
            opacity: 0,
          })
        },
        onEnterBack: () => {
          this.$refs['btn-fixed-left-wrapper'].style.position = 'fixed'
        },
        onLeave: () => {
          this.$refs['btn-fixed-left-wrapper'].style.position = 'absolute'
        },
        onLeaveBack: () => {
          gsap.to(this.$refs['btn-liner-list'], {
            display: 'none',
            opacity: 0,
          })

          gsap.to(this.$refs['btn-reference-list'], {
            display: 'block',
            opacity: 1,
          })
        },
        // markers: true
      })
    }

    // const pin = gsap.utils.toArray('.pin')
    // if (pin.length) {
    //   gsap.to(pin, {
    //     scrollTrigger: {
    //       trigger: '.pin',
    //       start: 'top center',
    //       end: 'top 100px',
    //       scrub: true,
    //       pin: true,
    //       markers: true,
    //     },
    //     y: '-100px',
    //     duration: 3
    //   })
    // }

    // Reveals bottom
    // const revealsBottom = gsap.utils.toArray('.reveal-bottom')
    // revealsBottom.forEach(element => {
    //   gsap.to(element, {
    //     scrollTrigger: {
    //       trigger: element,
    //       start: 'top 80%',
    //       markers: false,
    //       toggleActions: 'play none none none'
    //     },
    //     opacity: 1,
    //     y: 0,
    //     duration: 1,
    //     // ease: Elastic.out(1, 0.3)
    //   })
    // })

    // Reveals top
    // const revealsTop = gsap.utils.toArray('.reveal-top')
    // revealsTop.forEach(element => {
    //   gsap.to(element, {
    //     scrollTrigger: {
    //       trigger: element,
    //       start: 'top 80%',
    //       markers: false,
    //       toggleActions: 'play none none none'
    //     },
    //     opacity: 1,
    //     y: 0,
    //     duration: 1,
    //     // ease: Elastic.out(1, 0.3)
    //   })
    // })

    // Reveals left
    // const revealsLeft = gsap.utils.toArray('.reveal-left')
    // revealsLeft.forEach(element => {
    //   gsap.to(element, {
    //     scrollTrigger: {
    //       trigger: element,
    //       start: 'top 80%',
    //       markers: false,
    //       toggleActions: 'play none none none'
    //     },
    //     opacity: 1,
    //     x: 0,
    //     duration: 1,
    //     // ease: Back.easeOut
    //   })
    // })

    // Applications Automations listing
    // let proxy = {
    //     skew: 0,
    //     clipPathOdd: 'polygon(0% 0%, 100% 0%, 100% 98%, 0% 95%)',
    //     clipPathEven: 'polygon(0% 0%, 100% 0%, 100% 95%, 0% 98%)'
    //   },
    //   clipPathSetterOdd = gsap.quickSetter(".clip-path.odd", "clipPath"),
    //   clipPathSetterEven = gsap.quickSetter(".clip-path.even", "clipPath"),
    //   clamp = gsap.utils.clamp(-20, 20),
    //   clampClipPath = gsap.utils.clamp(-2, 2)

    // ScrollTrigger.create({
    //   onUpdate: (self) => {
    //     let skew = clamp(self.getVelocity() / -300);
    //     let clipPath = 95 - clampClipPath(self.getVelocity() / -100)
    //     let clipPath2 = 98 - clampClipPath(self.getVelocity() / 100)

    //     // only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
    //     if (Math.abs(skew) > Math.abs(proxy.skew)) {
    //       proxy.skew = skew
    //       proxy.clipPathOdd = 'polygon(0% 0%, 100% 0%, 100% ' + clipPath2 + '%, 0% ' + clipPath + '%)'
    //       proxy.clipPathEven = 'polygon(0% 0%, 100% 0%, 100% ' + clipPath + '%, 0% ' + clipPath2 + '%)'

    //       gsap.to(proxy, {
    //         skew: 0,
    //         clipPathOdd: 'polygon(0% 0%, 100% 0%, 100% 98%, 0% 95%)',
    //         clipPathEven: 'polygon(0% 0%, 100% 0%, 100% 95%, 0% 98%)',
    //         duration: 0.8,
    //         ease: "power3",
    //         overwrite: true,
    //         onUpdate: () => {
    //           clipPathSetterOdd(proxy.clipPathOdd)
    //           clipPathSetterEven(proxy.clipPathEven)
    //         }
    //       });
    //     }
    //   }
    // })

    // make the right edge "stick" to the scroll bar. force3D: true improves performance
    // gsap.set(".clip-path", {
    //   force3D: true
    // })
  }
}